<script setup lang="ts">
/* eslint-disable max-len */
export interface IconClipProps {
  width?: number;
  height?: number;
  fill?: string;
}

const props = withDefaults(defineProps<IconClipProps>(), {
  width: 10,
  height: 10,
  fill: "#A9B7D1",
});
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="8bc3o9xzsa">
        <path d="M1440 0v1882H0V0h1440z" />
      </clipPath>
      <clipPath id="au7fvo3dab">
        <path d="M5.6 0c.653 0 1.195.472 1.31 1.09C7.527 1.206 8 1.748 8 2.4v4.267C8 7.403 7.403 8 6.667 8H2.4a1.334 1.334 0 0 1-1.31-1.09A1.334 1.334 0 0 1 0 5.6V1.333C0 .597.597 0 1.333 0zm0 .533H1.333c-.44 0-.8.36-.8.8V5.6c0 .347.224.64.534.752V2.4c0-.736.597-1.333 1.333-1.333h3.952A.803.803 0 0 0 5.6.533zM3.867 3.235a.278.278 0 0 0-.267 0 .268.268 0 0 0-.133.232V5.6a.262.262 0 0 0 .267.267.27.27 0 0 0 .133-.035l1.866-1.067a.268.268 0 0 0 0-.464z" />
      </clipPath>
    </defs>
    <g clip-path="url(#8bc3o9xzsa)" transform="translate(-1008 -402)">
      <g clip-path="url(#au7fvo3dab)" transform="translate(1008 402)">
        <path :fill="props.fill" d="M0 0h8v8H0V0z" />
      </g>
    </g>
  </svg>
</template>
